import '../close-button.tag'
import '../bullet-bar/bullet.tag'

riot.tag2('viz-legend', '<close-button onclick="{close}"></close-button> <h3>Legende</h3> <p>Jeder Punkt ist eine Messstelle. Die Position auf der Skala gibt den zuletzt gemessenen Wert an. Klicke auf einen Punkt, um Informationen zu dieser Messstelle zu sehen. Klicke auf eine Gemeinde oder einen Balken, um alle Messstellen dieser Gemeinde zu sehen.</p> <div class="bullet-bar"> <div class="bullet-bar__bar-wrapper"> <div class="bullet-bar__spacer"></div> <div class="bullet-bar__bar" riot-style="width:{75}%;" onclick="{null}"></div> <span class="bullet-bar__tick bullet-bar__tick--50" riot-style="left:{50 / 3}%;"> <span>Grenzwert</span> </span> <span class="bullet-bar__tick legend__tick" riot-style="left:{150 / 3}%;"> <span>Messstelle</span> </span> <span class="bullet-bar__tick legend__tick --hidden" riot-style="left:{75}%;"> <span class="--top">Messstelle mit höchstem<br>Wert für ihre Stadt</span> </span> <bullet data="{data.example}" onclick="{null}"></bullet> <bullet data="{data.maxData}" onclick="{null}"></bullet> </div> </div>', '', 'class="infobox legend {-visible: visible}"', function(opts) {

  this.visible = true
  this.data = {
    example: {
      value: 150,
      legend: true
    },
    maxData: {
      value: 75 * 3,
      legend: true
    }
  }

  this.close = () => this.update({visible: false})

  riot.control.on(riot.EVT.showLegend, () => {
    this.update({visible: true})
  })

});



// WEBPACK FOOTER //
// ./src/components/legend/legend.tag